var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4892,
    cy: 21.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26541)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 43.5681,
    width: 12.1023,
    height: 43.5682,
    transform: "rotate(-90 0.705078 43.5681)",
    fill: "#009B77"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 31.4658,
    width: 19.3636,
    height: 43.5682,
    transform: "rotate(-90 0.705078 31.4658)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 12.1023,
    width: 12.1023,
    height: 43.5682,
    transform: "rotate(-90 0.705078 12.1023)",
    fill: "#FF9E42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.356 21.7842C30.356 26.1287 26.8341 29.6507 22.4895 29.6507C18.145 29.6507 14.623 26.1287 14.623 21.7842C14.623 17.4397 18.145 13.9177 22.4895 13.9177C26.8341 13.9177 30.356 17.4397 30.356 21.7842ZM23.9868 27.0218C23.5111 27.1576 23.0088 27.2302 22.4895 27.2302C21.9703 27.2302 21.468 27.1575 20.9923 27.0218L22.4895 25.3429L23.9868 27.0218ZM24.2055 26.9544C25.2381 26.6118 26.1335 25.9686 26.788 25.1285L24.4788 24.6641L24.2055 26.9544ZM26.845 25.0541C27.5297 24.1435 27.9355 23.0113 27.9355 21.7842C27.9355 21.7842 27.9355 21.7842 27.9355 21.7842C27.9355 20.5572 27.5298 19.4249 26.8451 18.5144L25.7103 20.6839L27.9355 21.7842L25.7102 22.8846L26.845 25.0541ZM26.7881 18.4399C26.1336 17.5998 25.2382 16.9566 24.2056 16.6141L24.4788 18.9043L26.7881 18.4399ZM23.9868 16.5466L22.4895 18.2255L20.9923 16.5466C21.468 16.4108 21.9703 16.3382 22.4895 16.3382C23.0088 16.3382 23.5111 16.4109 23.9868 16.5466ZM20.7736 16.614C19.741 16.9566 18.8455 17.5998 18.1909 18.4399L20.5002 18.9043L20.7736 16.614ZM18.134 18.5144C17.4493 19.4249 17.0435 20.5572 17.0435 21.7842C17.0435 21.7841 17.0435 21.7842 17.0435 21.7842C17.0435 23.0112 17.4493 24.1434 18.134 25.054L19.2688 22.8845L17.0435 21.7842L19.2689 20.6838L18.134 18.5144ZM18.1909 25.1285C18.8455 25.9686 19.7409 26.6118 20.7735 26.9544L20.5002 24.6641L18.1909 25.1285Z",
    fill: "#004692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIndia);
export default __webpack_public_path__ + "static/media/IN India.e741b0813f473a29bda7539b85483411.svg";
export { ForwardRef as ReactComponent };